import { getCustomerProfile, updateCustomerProfile } from 'api/customer/profile';
import { getMyPayments } from 'api/customer/payment';
import { useCustomerState } from 'providers/CustomerProvider';
import { getUserInStorage, setNavigationInStorage, setWorkDaysInStorage, setWorkHoursInStorage } from 'lib/Storage';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useSnackbar } from 'notistack';


function useCustomerProfile() {

  const [customer, setCustomer] = useCustomerState();
  return useQuery('customerProfile', getCustomerProfile, {
    onSuccess: (data) => {
      if(getUserInStorage()?.isAdmin) return;
      
      setCustomer({ ...customer, ...data?.customer });
      setWorkDaysInStorage(data?.workDays);
      setWorkHoursInStorage(data?.workHours);
      setNavigationInStorage(data?.navigations);
    },
    onError:(err)=>{
      return false;
    }
  });
}

function useMyPayments(){
  return useQuery('myPayments', getMyPayments);
}

function useUpdateMyProfile() {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  return useMutation(updateCustomerProfile, {
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onSuccess: (_, id) => {
      queryClient.invalidateQueries(['customerProfile', id]);
      enqueueSnackbar('مشخصات شما با موفقیت ویرایش شد', { variant: 'success' });
    },
  });
}

export { useCustomerProfile, useMyPayments, useUpdateMyProfile };
